export default __webpack_public_path__ + "static/media/community.7853e417.svg";